import React, {Component} from 'react';
import Moment from 'react-moment';
import {connect} from 'react-redux';
import {formatarReal} from '../../util/numberUtil';
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {excluirCentroCusto, selecionaCentroCusto} from '../../actions/centro-custo';
import alterarExibicaoDetalhamentoCentroCusto from '../../actions/centro-custo/alterarExibicaoDetalhamentoCentroCusto'
import {buscarTiposOcorrenciaCentroCusto} from '../../actions/centro-custo/index';
import moment from 'moment';
import DetalhesCentroCusto from './DetalhesCentroCusto';
import baixarComprovanteTransferencia from '../../actions/repasse-venda/baixarComprovanteTransferencia';

class CentroCusto extends Component {

    selecionarCentroCusto() {
        const {centroCusto} = this.props;
        this.props.buscarTiposOcorrenciaCentroCusto();
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoOcorrencia', {value: centroCusto.tipoOcorrencia, label: centroCusto.descTipoOcorrencia});
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoEventoOcorrencia', {value: centroCusto.tipoEventoOcorrencia, label: centroCusto.descTipoEventoOcorrencia});
        this.props.changeFieldValue('formularioPainelCentroCusto', 'ocorrencia', centroCusto.ocorrencia);
        this.props.changeFieldValue('formularioPainelCentroCusto', 'valorTotalGasto', centroCusto.valorTotalGasto);
        this.props.selecionarDataOcorrencia(moment(centroCusto.dataOcorrencia).toDate());
        this.props.selecionaCentroCusto(centroCusto);
        if (this.props.scrollToForm) {
            this.props.scrollToForm();
        }
    }

    baixarComprovante(urlComprovante, nomeComprovante) {
        baixarComprovanteTransferencia(urlComprovante, nomeComprovante).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeComprovante);
            document.body.appendChild(link);
            link.click();
        });
    }

    render() {
        const {centroCusto} = this.props;
        const isSelecionado = centroCusto.selecionado;
        return (
            <div className="vx-row-item" style={isSelecionado ? { borderLeft: '3px solid #FF6A00' } : {}}>
                <div className="vx-row-item-inner vx-row-item-inner--centro-custo">
                    <div className="vx-row-cell">
                        <button className="vx-row-expand-btn"
                            onClick={() => this.props.alterarExibicaoDetalhamentoCentroCusto(centroCusto)}>
                            <span className="material-icons">{centroCusto.exibirDetalhe ? 'expand_less' : 'expand_more'}</span>
                        </button>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data Entrada</span>
                        <Moment format="DD/MM/YYYY">{centroCusto.dataEntrada}</Moment>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Registrado Por</span>
                        {centroCusto.registradoPor}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Data Ocorrência</span>
                        <Moment format="DD/MM/YYYY">{centroCusto.dataOcorrencia}</Moment>
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Tipo Ocorrência</span>
                        {centroCusto.descTipoOcorrencia}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Tipo Evento</span>
                        {centroCusto.descTipoEventoOcorrencia}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Valor Total</span>
                        {formatarReal(centroCusto.valorTotalGasto)}
                    </div>
                    <div className="vx-row-cell">
                        <span className="vx-row-cell-label">Ações</span>
                        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                            <button type="button" className="vx-act-btn vx-act-btn--delete"
                                title="Excluir centro de custo"
                                data-toggle="modal"
                                data-target="#modalExcluirCentroCusto"
                                onClick={() => this.props.selecionaCentroCusto(centroCusto)}>
                                <span className="material-icons">delete</span>
                            </button>
                            <button type="button" className="vx-act-btn vx-act-btn--edit"
                                title="Editar"
                                onClick={() => this.selecionarCentroCusto()}>
                                <span className="material-icons">edit</span>
                            </button>
                            <button type="button"
                                className="vx-act-btn vx-act-btn--neutral"
                                style={!centroCusto.urlComprovante ? { opacity: .4, cursor: 'not-allowed' } : {}}
                                title={centroCusto.urlComprovante ? 'Baixar comprovante' : 'Sem comprovante'}
                                onClick={() => {
                                    if (centroCusto.urlComprovante) {
                                        this.baixarComprovante(centroCusto.urlComprovante, centroCusto.nomeComprovante);
                                    }
                                }}>
                                <span className="material-icons">get_app</span>
                            </button>
                        </div>
                    </div>
                </div>
                <DetalhesCentroCusto centroCusto={centroCusto} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tiposOcorrenciaCentroCusto: state.centroCusto.tiposCentroCusto || [],
});

const mapDispatchToProps = {
    changeFieldValue,
    alterarExibicaoDetalhamentoCentroCusto,
    excluirCentroCusto,
    buscarTiposOcorrenciaCentroCusto,
    selecionaCentroCusto,
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCentroCusto',
})(CentroCusto));
